import { PrintCardMenu } from './print-card-menu';
import { AssetLibraryType } from '../../enum/dto/asset-library-type.enum';
import { FONT, FontStyleSheet } from '../font-style-sheets';

export class FikaPrintCardMenu extends PrintCardMenu {
  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [
      FONT.NeueHaasGroteskDisplay.Regular_400,
      FONT.NeueHaasGroteskDisplay.Medium_500,
      FONT.NeueHaasGroteskDisplay.SemiBold_600,
      FONT.NeueHaasGroteskDisplay.Bold_700
    ];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/wxq6frp.css';
  }

  shouldFetchVariantAssets(): boolean {
    return true;
  }

  variantAssetTypeSortOrder(): string[] {
    return [AssetLibraryType.PrimaryBrand, AssetLibraryType.AlternateBrand, AssetLibraryType.Brand];
  }

  shouldStandardizeDominantStrainType(): boolean {
    return false;
  }
}
